import { render, staticRenderFns } from "./ReciboParticular.vue?vue&type=template&id=5bcd3fd5&"
import script from "./ReciboParticular.vue?vue&type=script&lang=js&"
export * from "./ReciboParticular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports